module.exports = __webpack_public_path__ + "img/insta.0d88a076.svg";